// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","highImportance":"AlertIconsCell_highImportance__NPkR-","icon":"AlertIconsCell_icon__D2eSH"};